import classNames from 'classnames';
import type { ReactHTML } from 'react';
import React from 'react';
import { Visibility, VisibilityOff } from './Icons';
import styles from './PrivacyIndicator.module.scss';

interface PrivacyIndicatorProps<T extends keyof ReactHTML> extends React.HTMLAttributes<T> {
  element?: T;
  isPublic?: boolean;
}

const PrivacyIndicator = React.memo(
  <T extends keyof ReactHTML = 'div'>({
    element,
    isPublic,
    className,
    ...props
  }: PrivacyIndicatorProps<T>) =>
    React.createElement(
      element ?? 'div',
      { className: classNames(className, styles.privacyIndicator), ...props },
      isPublic ? <Visibility /> : <VisibilityOff />,
      isPublic ? 'Visible to Managers & Admins' : 'Only visible to you'
    )
);

PrivacyIndicator.displayName = 'PrivacyIndicator';

export default PrivacyIndicator;
